import { render, staticRenderFns } from "./MuiAvatar.vue?vue&type=template&id=1ce87fdb&scoped=true"
import script from "./MuiAvatar.vue?vue&type=script&lang=js"
export * from "./MuiAvatar.vue?vue&type=script&lang=js"
import style0 from "./MuiAvatar.vue?vue&type=style&index=0&id=1ce87fdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce87fdb",
  null
  
)

export default component.exports